import React from 'react';
import { FormikValues } from 'formik';
import CardItem from 'src/components/Common/card';
import ReportListingForm, {
  IReportListingFormikValues,
} from 'src/components/Common/forms/ReportListingForm';
import ListingApis from 'src/api/listings';
import useUser from 'src/hooks/auth/useUser';
import { useNotifier } from 'src/contexts/notification/notification.context';

type TProps = {
  listingId: string;
};

const Report = ({ listingId }: TProps) => {
  const { accessToken } = useUser();
  const { errorAlert, successAlert } = useNotifier();

  const handleSubmit = async (values: IReportListingFormikValues | FormikValues) => {
    try {
      const model = new FormData();
      model.append('type', values.option);
      model.append('description', values.details);
      const result = await ListingApis.reportListing({
        token: accessToken,
        id: listingId,
        model,
      });
      if (result.status === 200) {
        successAlert(result.data.message);
      } else {
        errorAlert(result.data.message);
      }
    } catch (error) {
      console.log(error);
      errorAlert('Something went wrong');
    }
  };

  return (
    <CardItem title="Report this Ad">
      <ReportListingForm handleReportSubmit={handleSubmit} />
    </CardItem>
  );
};

export default Report;
